<template>
    <SummaryContainer
        :project="selectedProject"
        :month="selectedMonth"
        @change-month="handleSelectMonth"
    />
</template>

<script>
import SummaryContainer from '@/modules/Summary'
import store from '@/store'
import SummaryStore from '@/modules/Summary/_store'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
const STORE_KEY = '$_summary'
export default {
    components: {
        SummaryContainer
    },
    setup () {
        const {
            selectedGroup,
            selectedProject,
            projectIdxs,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            selectedMonth,
            handleSelectMonth
        } = useSelectMonth()
        if (selectedGroup.value?.groupIdx) {
            setInitialAccountSelect(false)
        } else {
            if (selectedProject.value?.projectIdx) {
                setInitialAccountSelect(true)
            } else {
                setInitialAccountSelect(false)
            }
        }
        const projectIdx = selectedProject.value?.projectIdx ? [selectedProject.value?.projectIdx] : projectIdxs.value
        store.dispatch(`${STORE_KEY}/getSummary`, { projectIdx, month: selectedMonth.value }).then(response => {
            if (selectedProject.value?.projectIdx) {
                store.dispatch(`${STORE_KEY}/getAvailableInvoice`, { usageAccountId: selectedProject.value.usageAccountId, month: selectedMonth.value })
            }
        })
        return {
            selectedProject,
            selectedMonth,
            handleSelectMonth
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, SummaryStore)
        }
        next()
    }
}
</script>

<style>

</style>
